import { Component, OnInit } from '@angular/core';
import { AuthService, Color } from '../auth.service';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { Observable, of } from 'rxjs';

@Component({
  selector: 'app-color',
  standalone: true,
  imports: [CommonModule, FormsModule],
  templateUrl: './color.component.html',
  styleUrl: './color.component.css'
})
export class ColorComponent implements OnInit {
  colors$: Observable<Color[]> = of([]);
  selectedColor: Color | null = null;
  newColor: Color = { id: 0, title: '', colorCode: '', mission: '' };
  errorMessage: string | null = null;

  constructor(private authService: AuthService) { }

  ngOnInit(): void {
    this.getColors();
  }

  getColors(): void {
    this.colors$ = this.authService.getColor();
  }

  saveColor(): void {
    if (this.validateColor(this.newColor)) {
      if (this.selectedColor && this.selectedColor.id) {
        this.updateColor();
      } else {
        this.createColor();
      }
    } else {
      this.errorMessage = 'Either mission or color_code must be filled, but not both.';
    }
  }

  validateColor(color: Color): boolean {
    const hasColorCode = color.colorCode.trim() !== '';
    const hasMission = color.mission.trim() !== '';
    return (hasColorCode || hasMission) && !(hasColorCode && hasMission);
  }

  createColor(): void {
    this.authService.createColor(this.newColor).subscribe(
      () => {
        this.getColors();
        this.resetForm();
      },
      (error) => this.errorMessage = 'Erreur lors de la création de la couleur'
    );
  }

  updateColor(): void {
    if (this.selectedColor) {
      // Assurez-vous que newColor a les valeurs que vous voulez envoyer
      this.selectedColor.title = this.newColor.title; // Ajout de la mise à jour du titre
      this.selectedColor.colorCode = this.newColor.colorCode;
      this.selectedColor.mission = this.newColor.mission;

      this.authService.updateColor(this.selectedColor.id, this.selectedColor).subscribe(
        response => {
          console.log(response); // Vérifiez la réponse du serveur
          this.getColors(); // Recharge la liste des couleurs
          this.resetForm(); // Réinitialise le formulaire
        },
        (error) => this.errorMessage = 'Erreur lors de la mise à jour de la couleur'
      );
    }
  }


  deleteColor(id: number): void {
    this.authService.deleteColor(id).subscribe(
      () => this.getColors(),
      (error) => this.errorMessage = 'Erreur lors de la suppression de la couleur'
    );
  }

  editColor(color: Color): void {
    this.selectedColor = { ...color };
    this.newColor = { ...color }; // Met à jour newColor avec les valeurs de la couleur sélectionnée
  }

  resetForm(): void {
    this.newColor = { id: 0, title: '', colorCode: '', mission: '' };
    this.selectedColor = null;
  }

}
